import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'



export const processaRegistrosDefaultIniciaisExclusaoFamiliares = ( values ) => {

    if (!values.exclusaoFamiliares) {

        values.exclusaoFamiliares = JSON.parse(JSON.stringify(HARDCODE.exclusaoFamiliaresInit))
    }
}



export const obtemExclusaoFamiliaresList = ( values, id ) => {

    let exclusaoFamiliaresList = []

    familiaresList(values)?.forEach( ( linhaFamiliaresList, index ) => {
            
        if (
                (
                    linhaFamiliaresList.id !== HARDCODE.idFamiliarCliente &&
                    linhaFamiliaresList.id !== HARDCODE.idFamiliarConjuge
                ) ||
                (
                    (
                        linhaFamiliaresList.id === HARDCODE.idFamiliarCliente &&
                        !pesquisaList(values.exclusaoFamiliares, HARDCODE.idFamiliarConjuge).id
                    ) ||
                    id === HARDCODE.idFamiliarConjuge
                ) ||
                (
                    (
                        linhaFamiliaresList.id === HARDCODE.idFamiliarConjuge &&
                        !pesquisaList(values.exclusaoFamiliares, HARDCODE.idFamiliarCliente).id
                    ) ||
                    id === HARDCODE.idFamiliarCliente
                )
        ) {

            exclusaoFamiliaresList.push(
                linhaFamiliaresList
            )
        }
    })



    let index = values.exclusaoFamiliares.length - 1

    while (index >= 0) {

        if (
                values.exclusaoFamiliares[index].id &&
                !pesquisaList(exclusaoFamiliaresList, values.exclusaoFamiliares[index].id).id
        ) {

            values.exclusaoFamiliares.splice(index, 1)
        }

        index -= 1
    }



    index = exclusaoFamiliaresList.length - 1

    while (index >= 0) {

        if (
                exclusaoFamiliaresList[index].id !== id &&
                pesquisaList(values.exclusaoFamiliares, exclusaoFamiliaresList[index].id).id
        ) {

            exclusaoFamiliaresList.splice(index, 1)
        }

        index -= 1
    }

    return exclusaoFamiliaresList
}